import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import {
  Component,
  DOCUMENT,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subscription } from 'rxjs';
import { AddEditDataSpaceComponent } from '../../models/add-edit-data-space/add-edit-data-space.component';
import { AuthService } from '../../services/auth.service';
import { ModalService } from '../../services/modal.service';
import { PageTitleService } from '../../services/pageTitle.service';
import { AgentAction } from './agent-action/agent-action';
import { HeaderRightComponent } from './header-right/header-right.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, HeaderRightComponent, NgbPopover, AgentAction],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public isCollapsed = true;
  pageInfo: any;
  description = '';
  hideUserAction = '';
  showEditIcon: any;
  d_pageName: string = '';
  private titleSubscription!: Subscription;
  private descriptionSubscription!: Subscription;
  private hideUserActionSubscription!: Subscription;
  hasWritePermission: boolean = false;
  rolePermission: boolean = false;
  roleId: string = '';
  dataSpaceId: string = '';
  apiId: string = '';
  apiName: string = '';

  isToggleClick: boolean = false;
  userInfo: any;
  isAgentChat: any = false;
  chatId: any;
  constructor(
    private readonly pageTitle: PageTitleService,
    private readonly location: Location,
    private readonly router: Router,
    private readonly _modalService: ModalService,
    private readonly _auth: AuthService,
    private readonly route: ActivatedRoute,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
  ) {}

  ngOnInit(): void {
    this.descriptionSubscription = this.pageTitle.description$.subscribe(
      (description) => (this.description = description),
    );

    this.titleSubscription = this.pageTitle.title$.subscribe((data) => {
      this.pageInfo = data;
    });

    this.hideUserActionSubscription = this.pageTitle.hideHeader$.subscribe(
      (hideHeader) => (this.hideUserAction = hideHeader),
    );
    this.getProfile();

    const url = this.router.url; // current URL
    this.isAgentChat = url.startsWith('/agent/chat');
    // read :id from deepest activated route
    let r = this.route;
    while (r.firstChild) r = r.firstChild;
    this.chatId = r.snapshot.paramMap.get('id'); // will change on navigation
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const url = this.router.url; // current URL
        this.isAgentChat = url.startsWith('/agent/chat');

        // read :id from deepest activated route
        let r = this.route;
        while (r.firstChild) r = r.firstChild;
        this.chatId = r.snapshot.paramMap.get('id'); // will change on navigation
      });
  }

  back(): void {
    if (this.pageInfo?.url) {
      this.router.navigate([this.pageInfo.url]);
    } else {
      this.location.back();
    }
  }
  editDataspace() {
    const editPopup = this._modalService.openModal(AddEditDataSpaceComponent, {});
    editPopup.componentInstance.isEdit = true;
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.titleSubscription) {
      this.titleSubscription.unsubscribe();
    }
    if (this.descriptionSubscription) {
      this.descriptionSubscription.unsubscribe();
    }
    if (this.hideUserActionSubscription) {
      this.hideUserActionSubscription.unsubscribe();
    }
  }

  toggleSidebar() {
    if (!isPlatformBrowser(this.platformId)) return;

    const body = this.document.body;
    body.classList.toggle('sidenavToggledMobile');
  }
  private getProfile(): void {
    this._auth.getUserProfile().subscribe({
      next: (res: any) => {
        this.userInfo = res;
      },
      error: (err: any) => {},
    });
  }
}
